import { RedirectEndpointEnum, RedirectFormValidationSchema, RedirectMatchModeEnum } from '@/modules/Sites';

export const redirectFormValidationSchema: RedirectFormValidationSchema = {
  sourceType: [{ type: 'enum', enum: [RedirectEndpointEnum.Node, RedirectEndpointEnum.Path], required: true }],
  sourceNodeId: [
    ({ getFieldValue }) => ({
      required: getFieldValue('sourceType') === RedirectEndpointEnum.Node,
      message: 'Оберіть сторінку',
    }),
  ],
  sourcePath: [
    ({ getFieldValue }) => ({
      required: getFieldValue('sourceType') === RedirectEndpointEnum.Path,
      message: 'Поле обов\'язкове для заповнення',
    }),
  ],
  targetType: [{ type: 'enum', enum: [RedirectEndpointEnum.Node, RedirectEndpointEnum.Path], required: true }],
  targetNodeId: [
    ({ getFieldValue }) => ({
      required: getFieldValue('targetType') === RedirectEndpointEnum.Node,
      message: 'Оберіть сторінку',
    }),
  ],
  targetPath: [
    ({ getFieldValue }) => ({
      required: getFieldValue('targetType') === RedirectEndpointEnum.Path,
      message: 'Поле обов\'язкове для заповнення',
    }),
  ],
  statusCode: [{ type: 'number', required: true, message: 'Оберіть код редіректу' }],
  matchMode: [{
    type: 'enum',
    enum: [RedirectMatchModeEnum.Exact, RedirectMatchModeEnum.Nested, RedirectMatchModeEnum.Prefix],
    required: true
  }],
  isActive: [{ type: 'boolean', required: true }],
  forVisitor: [],
  siteId: []
};
